import { render, staticRenderFns } from "./MfcInput.vue?vue&type=template&id=06c9087e&scoped=true&"
import script from "./MfcInput.vue?vue&type=script&lang=js&"
export * from "./MfcInput.vue?vue&type=script&lang=js&"
import style0 from "./MfcInput.vue?vue&type=style&index=0&id=06c9087e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9087e",
  null
  
)

export default component.exports